import { render, staticRenderFns } from "./SmartTag.vue?vue&type=template&id=7d3f2d9b"
import script from "./SmartTag.vue?vue&type=script&lang=js"
export * from "./SmartTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports